<template>
  <div
    class="sidebar-drawer"
    @click="drawerClickOutsideHandler"
  >
    <div
      ref="sidebarDrawer"
      class="sidebar-drawer-container"
      :class="{ 'active': open }"
    >
      <div
        class="sidebar-drawer-container__page1"
        :class="{ 'active': activePage === 1 }"
      >
        <ul class="sidebar-drawer-container__page1__list">
          <li
            class="sidebar-drawer-container__page1__list__item"
          >
            <nuxt-link
              :to="{name: 'serviceList'}"
              class="sidebar-drawer-container__page1__list__item__link"
              @click.native="logHeaderGaEvent('全部服務'); $emit('closeDrawer')"
            >
              全部服務
            </nuxt-link>
          </li>
          <li
            v-if="isShowApplianceCleaning"
            class="sidebar-drawer-container__page1__list__item"
            @click="goToPage3(applianceCleaningID, '家電清洗'); logHeaderGaEvent('家電清洗')"
          >
            家電清洗
            <i class="icon-chevron-right sidebar-drawer-container__page1__list__item__icon" />
          </li>
          <li
            v-if="isShowHomeCleaning"
            class="sidebar-drawer-container__page1__list__item"
            @click="goToPage3(homeCleaningID, '居家清潔'); logHeaderGaEvent('居家清潔')"
          >
            居家清潔
            <i class="icon-chevron-right sidebar-drawer-container__page1__list__item__icon" />
          </li>
          <li class="sidebar-drawer-container__page1__list__item">
            <a
              class="sidebar-drawer-container__page1__list__item__link"
              href="https://top1.kingnet.net.tw/"
              target="_blank"
              @click="logHeaderGaEvent('今網寬頻')"
            >
              今網寬頻
            </a>
          </li>
          <li class="sidebar-drawer-container__page1__list__item">
            <nuxt-link
              class="sidebar-drawer-container__page1__list__item__link"
              :to="{ name: 'informationStation', params: { toTop: true } }"
              @click.native="logHeaderGaEvent('生活情報站')"
            >
              生活情報站
            </nuxt-link>
          </li>
          <li class="sidebar-drawer-container__page1__list__item">
            <a
              class="sidebar-drawer-container__page1__list__item__link"
              href="https://www.smartdaily.com.tw/household/"
              target="_blank"
              @click="logHeaderGaEvent('關於我們')"
            >
              關於我們
            </a>
          </li>
          <li class="divider" />
          <li
            class="sidebar-drawer-container__page1__list__item"
            @click="activePage = 2"
          >
            會員專區
            <i class="icon-chevron-right sidebar-drawer-container__page1__list__item__icon" />
            <img
              v-if="showAlertIcon"
              class="sidebar-drawer-container__page1__list__item__img"
              src="@/assets/image/edit-alert.svg"
            >
          </li>
        </ul>
      </div>
      <div
        class="sidebar-drawer-container__page2"
        :class="{ 'active': activePage === 2 }"
      >
        <li
          class="sidebar-drawer-container__page2__title sidebar-drawer-container__page2__list__item"
          @click="activePage = 1"
        >
          <i class="icon-arrow-left-bold sidebar-drawer-container__page2__list__item__icon" />
          會員專區
        </li>
        <NavMemberDropDownMenu
          @logout="$emit('logout')"
        />
      </div>
      <div
        class="sidebar-drawer-container__page3"
        :class="{ 'active': activePage === 3 }"
      >
        <li
          class="sidebar-drawer-container__page3__title sidebar-drawer-container__page3__list__item"
          @click="activePage = 1"
        >
          <i class="icon-arrow-left-bold sidebar-drawer-container__page3__list__item__icon" />
          {{ page3Title }}
        </li>
        <v-skeleton-loader
          v-show="serviceIsLoading && activePage === 3"
          type="article"
        />
        <div v-show="!serviceIsLoading">
          <NavListItem
            v-for="childrenType in page3SubTypeList"
            :key="childrenType.typeId"
            :children-type-item="childrenType"
            :type-parent-id="page3TypeParentId"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NavMemberDropDownMenu from '@/components/Nav/NavMemberDropdownMenu'
import NavListItem from './NavListItem.vue'
export default {
  components: {
    NavMemberDropDownMenu,
    NavListItem
  },
  props: {
    open: Boolean,
    allService: {
      type: Array,
      default: () => []
    },
    serviceIsLoading: Boolean
  },
  data () {
    return {
      activePage: 1,
      allServiceByMainType: [],
      page2ActiveTab: '',
      page3Title: '',
      page3SubTypeList: [],
      page3TypeParentId: null,
      categoryDropdownID: {
        applianceCleaning: { dev: 109, prod: 157 },
        homeCleaning: { dev: 7, prod: 1 }
      },
      isDev: this.$nuxt.context.env.NODE_ENV_NAME !== 'ec' && this.$nuxt.context.env.NODE_ENV_NAME !== 'staging'
    }
  },
  computed: {
    ...mapGetters(['isGuestMember', 'hasRedPoint']),
    showAlertIcon () {
      return this.isGuestMember || (
        this.$auth.loggedIn &&
        this.$auth.user &&
        !this.$auth.user.IsServiceAccountTransferEnd
      )
    },
    applianceCleaningID () {
      const { dev, prod } = this.categoryDropdownID.applianceCleaning
      return this.isDev ? dev : prod
    },
    homeCleaningID () {
      const { dev, prod } = this.categoryDropdownID.homeCleaning
      return this.isDev ? dev : prod
    },
    isShowApplianceCleaning () {
      return this.showService(this.applianceCleaningID)
    },
    isShowHomeCleaning () {
      return this.showService(this.homeCleaningID)
    }
  },
  watch: {
    allService: {
      handler (val) {
        this.allServiceByMainType = _.cloneDeep(val)
      },
      immediate: true
    }
  },
  methods: {
    showService (id) {
      const service = this.allService.find((service) => service.typeParent === id)
      if (!service) return false
      if (!service.subTypeList) return false
      return service.subTypeList.length > 0
    },
    logHeaderGaEvent (headerName) {
      this.$gaLogEvent('導覽列', `header_${headerName}`)
    },
    drawerClickOutsideHandler (event) {
      const drawer = this.$refs.sidebarDrawer
      if (!(drawer === event.target || drawer.contains(event.target))) { if (this.open) this.$emit('closeDrawer') }
    },
    goToPage3 (id, title) {
      this.activePage = 3
      this.page3TypeParentId = id
      this.page3Title = title
      const found = this.allService.find(item => item.typeParent === id)
      this.page3SubTypeList = found ? found.subTypeList : []
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-drawer {
  width: 100vw;
  height: 100vh;
  position: relative;
  display: none;
  transition: all 0.2s ease-in;
  opacity: 0;

  &.active {
    background: rgba(72, 72, 72, 0.6);
    opacity: 1;
  }
}

.sidebar-drawer-container {
  @mixin arrowIconStyle {
    color: $color-caption;
    font-weight: bold;
    font-size: 18px;
  }

  position: fixed;
  top: $headerHeightMobile;
  bottom: 0;
  right: 0;
  background: $color-background-secondary;
  width: 300px;
  max-width: 80vw;
  transform: translateX(100%);
  transition: all 0.2s ease-in;
  overflow: hidden;
  overflow-y: scroll;
  color: $color-text-primary;

  &.active {
    transform: translateX(0);
  }

  &__page1 {
    transform: translateX(-100%);

    &__list__item {
      &__icon {
        @include arrowIconStyle;
        margin-left: 8px;
      }

      &__img {
        margin-left: 8px;
      }
    }
  }

  &__page2, &__page3 {
    transform: translateX(100%);

    &__title {
      padding: 12px 10px;
      list-style: none;
    }

    &__list__item__icon {
      @include arrowIconStyle;
      margin-right: 4px;
    }
  }

  &__page1,
  &__page2,
  &__page3 {
    position: absolute;
    top: 0;
    transition: transform 0.2s ease-in;
    width: 100%;
    max-height: calc(100vh - #{$headerHeightMobile});
    overflow: hidden;

    &.active {
      transform: translateX(0);
      overflow: auto;
      max-height: none;
    }

    &__list {
      list-style: none;
      padding: 12px 32px 32px;

      &__item {
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-top: 20px;
        color: $color-text-primary;
        font-weight: bold;

        &__link {
          width: 100%;
          text-decoration: none;
          color: $color-text-primary;

          &:active {
            color: $color-primary;
          }
        }
      }

      .divider {
        height: 1px;
        background: $color-border-primary;
        width: 100%;
        margin: 30px 0;
      }
    }
  }

  &__page3 {
    &__title {
      margin-bottom: 4px;
    }
    ::v-deep {
      .title-list-items-box__container {
        padding-left: 34px;
        margin-bottom: 24px;
        &__link-title {
          font-size: pxTorem(16px);
        }
      }
    }
  }
}

.nav-dropdown-menu__service-list {
  width: calc(100% - 216px);
  display: inline-flex;
  writing-mode: vertical-lr;
  flex-wrap: wrap;
  align-content: flex-start;
  padding: 24px 0 24px 34px;
  overflow: scroll;

  &__container {
    writing-mode: horizontal-tb;
    min-width: 200px;
    max-width: 250px;
    vertical-align: top;
    margin-bottom: 30px;
    margin-right: 30px;
    display: inline-block;
  }

  &__link-title {
    text-decoration: none;
    font-weight: bold;
    font-size: pxTorem(16px);
    position: relative;
    padding-left: 15px;
    line-height: pxTorem(24px);
    display: flex;
    align-items: center;
    color: $color-text-primary;

    &::before {
      content: "";
      background-color: $color-primary;
      position: absolute;
      left: 0px;
      width: 6px;
      height: calc(100% - 4px);
    }

    &:hover {
      color: $color-primary;
    }
  }

  &__link-item {
    text-decoration: none;
    color: $color-text-primary;
    font-size: pxTorem(15px);
    font-weight: 400;
    margin-top: 16px;
    display: block;
    word-wrap: break-word;
    padding-left: 15px;

    &:hover {
      color: $color-primary;
    }
  }
}

::v-deep {
  .theme--light {
    &.v-expansion-panels {
      border-top: thin solid;
      border-bottom: thin solid rgba(0, 0, 0, 0.12);
      border-color: rgba(0, 0, 0, 0.12);
      border-radius: 0;

      .v-expansion-panel {
        color: $color-text-primary;

        button {
          font-weight: bold;
        }

        &::before {
          box-shadow: none;
        }
      }

      .v-expansion-panel-header {
        padding: 12px 28px;
        font-weight: bold;
        font-size: pxTorem(16px);

        &--active {
          color: $color-primary;

          .v-expansion-panel-header__icon .v-icon {
            color: $color-primary !important;
          }
        }
      }
    }
  }
  .v-expansion-panel-content__wrap {
    padding: 0px 28px;
  }
}
/** 手機 */
@media screen and (max-width: $mobileWidth) {
  .sidebar-drawer {
    display: block;
  }
}
</style>
